import {CustomCssVarsFn} from '@wix/yoshi-flow-editor'

import {StylesParamsType, AlignmentToJustifyContent} from '../../types/createStylesParams'
import {
  buttonDefaultStylesParams,
  buttonHoverStylesParams,
  ButtonDefaultStylesParams,
  ButtonHoverStylesParams,
} from '../../components-shared/Settings/Button/stylesParams'
import {
  linkStylesParams,
  LinkStylesParams,
} from '../../components-shared/Settings/Link/stylesParams'
import {
  formBoxStylesParams,
  formLineStylesParams,
  FormBoxStylesParams,
  FormLineStylesParams,
} from '../../components-shared/Settings/FormDesign/stylesParams'
import {
  timeSlotsDefaultStylesParams,
  timeSlotsSelectedStylesParams,
  timeSlotsClosedStylesParams,
  TimeSlotsDefaultStylesParams,
  TimeSlotsSelectedStylesParams,
  TimeSlotsClosedStylesParams,
} from '../../components-shared/Settings/TimeSlots/stylesParams'

import {
  areasLayoutStylesParams,
  AreasLayoutStylesParams,
  layoutStylesParams,
  LayoutStylesParams,
} from './Settings/Tabs/Layout/stylesParams'
import {generalStylesParams, GeneralStylesParams} from './Settings/Tabs/Design/General/stylesParams'
import {
  areasDefaultStylesParams,
  areasHoverStylesParams,
  areasSelectedStylesParams,
  AreasDefaultStylesParams,
  AreasHoverStylesParams,
  AreasSelectedStylesParams,
} from './Settings/Tabs/Design/Areas/stylesParams'

export type StylesParams = LayoutStylesParams &
  AreasLayoutStylesParams &
  GeneralStylesParams &
  FormBoxStylesParams &
  FormLineStylesParams &
  TimeSlotsDefaultStylesParams &
  TimeSlotsSelectedStylesParams &
  TimeSlotsClosedStylesParams &
  AreasDefaultStylesParams &
  AreasHoverStylesParams &
  AreasSelectedStylesParams &
  ButtonDefaultStylesParams &
  ButtonHoverStylesParams &
  LinkStylesParams

export const stylesParams: StylesParamsType<StylesParams> = {
  ...layoutStylesParams,
  ...areasLayoutStylesParams,
  ...generalStylesParams,
  ...formBoxStylesParams,
  ...formLineStylesParams,
  ...timeSlotsDefaultStylesParams,
  ...timeSlotsSelectedStylesParams,
  ...timeSlotsClosedStylesParams,
  ...areasDefaultStylesParams,
  ...areasHoverStylesParams,
  ...areasSelectedStylesParams,
  ...buttonDefaultStylesParams,
  ...buttonHoverStylesParams,
  ...linkStylesParams,
}

export default stylesParams

export const customCssVars: CustomCssVarsFn = ({styleParams}) => {
  const numbers = styleParams.numbers

  return {
    breadcrumbsAlignment: AlignmentToJustifyContent[numbers.breadcrumbsAlignment],
  }
}
